import React, { Component } from "react";
import { connect } from "react-redux";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import storageUtils from "../../utils/storageUtils";
import {
  req_page_lrs_spaceInformation,
  req_edit_lrs_spaceInformation,
  req_list_lrs_spaceSessionTimeStandard,
  req_list_lrs_specialdays,
} from "../../api";
import {
  Table,
  Select,
  Input,
  Card,
  Button,
  Switch,
  Modal,
  message,
  Tooltip,
} from "antd";
import SpaceModalDepartment from "./space-modal-department";
import SpaceModalManager from "./space-modal-manager";
import SpaceModalConfig from "./space-modal-config";
import SpaceModalDescription from "./space-modal-description";
import SpaceModalSessiontime from "./space-modal-sessiontime";
import SpaceModalCloseddate from "./space-modal-closeddate";
import SpaceModalConfirmor from "./space-modal-confirmor";
class SpaceManagement extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    domnloadFile: "",
    sessiontimes: [],
    sessiondates: [],
    specialdays: [],
    isShowDeppartmentModal: false,
    isShowManagerModal: false,
    isShowConfigModal: false,
    isShowDescriptionModal: false,
    isShowSessionTimeModal: false,
    isShowClosedDateModal: false,
    isShowConfirmorModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_lrs_spaceInformation(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_modify_item = async (condition, item) => {
    item.condition = condition;
    //console.log(item);
    const result = await req_edit_lrs_spaceInformation(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_list_sessiontimes = async (roomCode) => {
    const result = await req_list_lrs_spaceSessionTimeStandard(
      roomCode,
      "STANDARD",
      storageUtils.getUser().token
    );
    if (result.total) {
      const sessiontimes = result.total > 0 ? result.data : [];
      let sessiondates = [];
      this.groupBy(sessiontimes, "WeekCode").forEach((key) => {
        sessiondates.push(key);
      });
      this.setState({ sessiontimes, sessiondates });
      //console.log(sessionDates);
    }
  };

  api_list_specialdays = async (roomCode) => {
    const result = await req_list_lrs_specialdays(
      roomCode,
      storageUtils.getUser().token
    );
    if (result.total) {
      const specialdays = result.total > 0 ? result.data : [];
      this.setState({ specialdays });
    }
  };
  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "所在大樓",
        dataIndex: "BuildingName",
        width: 25,
        responsive: ["md"],
      },
      {
        title: "空間編號",
        dataIndex: "RoomCode",
        width: 25,
      },
      {
        title: "空間名稱",
        dataIndex: "RoomTwName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "管理單位",
        width: 35,
        responsive: ["md"],
        render: (item) => {
          const { ServiceUnitName } = item;
          return (
            <>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => this.handle_show_ui_modal("DEPARTMENT", item)}
              >
                <i className="fas fa-building"></i>{" "}
                {ServiceUnitName === "NONE" ? "未指定" : ServiceUnitName}
              </button>
            </>
          );
        },
      },
      {
        title: "管理人",
        width: 25,
        render: (item) => {
          const { ConfirmorATwName } = item;
          return (
            <>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => this.handle_show_ui_modal("MANGER", item)}
              >
                <i className="fas fa-user-lock"></i>{" "}
                {ConfirmorATwName === "NONE" ? "未指定" : ConfirmorATwName}
              </button>
            </>
          );
        },
      },
      {
        title: "是否出借",
        width: 25,
        responsive: ["md"],
        render: (item) => {
          const { RoomStatus } = item;
          return (
            <Switch
              checkedChildren="可外借"
              unCheckedChildren="不外借"
              defaultChecked={RoomStatus === "OPEN" ? true : false}
              onChange={(e) =>
                this.handle_ui_switch_process(item, "ROOM_STATUS", e)
              }
            />
          );
        },
      },
      {
        title: "審查等級",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { RoomStatus, MustConfirmLevel } = item;
          return (
            <>
              <select
                name="MustConfirmLevel"
                id="MustConfirmLevel"
                className="custom-select text-success"
                defaultValue={MustConfirmLevel}
                key={MustConfirmLevel}
                onChange={(e) =>
                  this.handle_confirmLevel_change(e.target.value, item)
                }
                disabled={RoomStatus === "OPEN" ? false : true}
              >
                <option value="C">須三審</option>
                <option value="B">須二審</option>
                <option value="A">須一審</option>
                <option value="O" disabled>
                  免審查
                </option>
              </select>
              {RoomStatus === "OPEN" ? (
                <button
                  className="btn btn-primary btn-sm"
                  style={{ width: "100%" }}
                  onClick={() => this.handle_show_ui_modal("CONFIRMOR", item)}
                >
                  審查人員
                </button>
              ) : (
                ""
              )}
            </>
          );
        },
      },
      {
        title: "相關設定",
        width: 40,
        responsive: ["md"],
        render: (item) => {
          const { RoomStatus } = item;
          return (
            <>
              {RoomStatus === "OPEN" ? (
                <>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() =>
                      this.handle_show_ui_modal("DESCRIPTION", item)
                    }
                  >
                    <i className="fas fa-book"></i> 借用說明
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => this.handle_show_ui_modal("TIME", item)}
                  >
                    <i className="fas fa-clock"></i> 開放時段
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => this.handle_show_ui_modal("DATE", item)}
                  >
                    <i className="fas fa-calendar-times"></i> 停借日期
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => this.handle_show_ui_modal("CONFIG", item)}
                  >
                    <i className="fas fa-tasks"></i> 更多組態
                  </button>
                </>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_color(type, param) {
    switch (type) {
      case "CONFIRM_LEVEL":
        switch (param) {
          case "A":
            return "PowderBlue";
          case "B":
            return "LightSkyBlue";
          case "C":
            return "DarkBlue";
          default:
            return "Black";
        }
      case "APPLY_TATUS":
        switch (param) {
          case "APPLY":
            return "DarkSlateBlue";
          case "AGREEA":
            return "PaleGreen";
          case "AGREEB":
            return "OliveDrab";
          case "AGREEC":
            return "DarkGreen";
          case "REFUSEA":
            return "DarkGray";
          case "REFUSEB":
            return "DimGray";
          case "REFUSEC":
            return "Black";
          case "CANCEL":
            return "SlateGray";
          default:
            return "Black";
        }

      default:
        return "Black";
    }
  }

  style_switch_text(type, param) {
    switch (type) {
      case "CONFIRM_LEVEL":
        switch (param) {
          case "A":
            return "只要一審";
          case "B":
            return "須到二審";
          case "C":
            return "須到三審";
          default:
            return "未定義";
        }
      case "APPLY_TATUS":
        switch (param) {
          case "APPLY":
            return "申請中";
          case "AGREEA":
            return "一審已同意";
          case "AGREEB":
            return "二審已同意";
          case "AGREEC":
            return "三審已同意";
          case "REFUSEA":
            return "一審不同意";
          case "REFUSEB":
            return "二審不同意";
          case "REFUSEC":
            return "三審不同意";
          case "CANCEL":
            return "已註銷";
          default:
            return "未定義";
        }

      default:
        return "Black";
    }
  }

  groupBy = function (array, prop) {
    return Object.keys(
      array.reduce(function (groups, item) {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
      }, {})
    );
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_ui_switch_process = (item, field, e) => {
    switch (field) {
      case "ROOM_STATUS":
        const { items } = this.state;
        const value = e === false ? "CLOSE" : "OPEN";
        items.forEach((record) => {
          if (record.Uid === item.Uid) {
            record.RoomStatus = value;
            this.api_modify_item("ROOMSTATUS", record);
          }
        });
        this.setState({ items });
        break;
      default:
    }
    //console.log(item);
  };

  handle_confirmLevel_change = (value, item) => {
    const { items } = this.state;
    items.forEach((obj) => {
      if (obj.Uid === item.Uid) {
        obj.MustConfirmLevel = value;
      }
    });

    const obj = {
      MustConfirmLevel: value,
      Uid: item.Uid,
    };

    this.api_modify_item("CONFIRMLEVEL", obj);
    this.setState({ items });
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "CONFIRMOR":
        this.setState({ isShowConfirmorModal: true });
        break;
      case "DEPARTMENT":
        this.setState({ isShowDepartmentModal: true });
        break;
      case "MANGER":
        this.setState({ isShowManagerModal: true });
        break;
      case "CONFIG":
        this.setState({ isShowConfigModal: true });
        break;
      case "DESCRIPTION":
        this.setState({ isShowDescriptionModal: true });
        break;
      case "TIME":
        const { RoomCode } = item;
        this.api_list_sessiontimes(RoomCode);
        this.setState({ isShowSessionTimeModal: true });
        break;
      case "DATE":
        this.setState({ isShowClosedDateModal: true });
        break;
      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      sessiontimes,
      sessiondates,
      specialdays,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowConfirmorModal,
      isShowDepartmentModal,
      isShowManagerModal,
      isShowConfigModal,
      isShowDescriptionModal,
      isShowSessionTimeModal,
      isShowClosedDateModal,
    } = this.state;
    const title = (
      <span>
        <Select
          value={searchField}
          style={{ width: 100 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="RoomCode">空間編號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search"></i> 查詢
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <p></p>
      </span>
    );

    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          columns={this.columns}
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
        />

        <Modal
          destroyOnClose={true}
          visible={isShowConfirmorModal}
          width={'60%'}
          onOk={() => {
            this.setState({ isShowConfirmorModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowConfirmorModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceModalConfirmor space={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowDepartmentModal}
          width={400}
          onOk={() => {
            this.setState({ isShowDepartmentModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowDepartmentModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceModalDepartment space={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowManagerModal}
          width={"50%"}
          onOk={() => {
            this.setState({ isShowManagerModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowManagerModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceModalManager space={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowConfigModal}
          width={400}
          onOk={() => {
            this.setState({ isShowConfigModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowConfigModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceModalConfig space={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowDescriptionModal}
          width={600}
          onOk={() => {
            this.setState({ isShowDescriptionModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowDescriptionModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceModalDescription space={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowSessionTimeModal}
          width={"100%"}
          onOk={() => {
            this.setState({ isShowSessionTimeModal: false });
            this.setState({ sessiontimes: [], sessiondates: [] });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isShowSessionTimeModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceModalSessiontime
            space={item}
            sessiondates={sessiondates}
            sessiontimes={sessiontimes}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowClosedDateModal}
          width={"70%"}
          onOk={() => {
            this.setState({ isShowClosedDateModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowClosedDateModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceModalCloseddate space={item} specialdays={specialdays} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SpaceManagement);
